import reducer, { initialState } from "./reducer";
import * as actions from "./actions";

export default { reducer, initialState, actions };
